export const DEFAULT_CHAIN_ID = parseInt((process.env.REACT_APP_DEFAULT_CHAIN_ID as string) ?? 1)

export const INFURA_API_KEY = process.env.REACT_APP_INFURA_API_KEY as string
export const FORTMATIC_API_KEY = process.env.REACT_APP_FORTMATIC_API_KEY as string

export const TEST_ENVIRONMENT =
  process.env.REACT_APP_TEST_ENVIRONMENT?.toLowerCase() === 'true' ?? false
